import styled from "styled-components";

const TagList = styled.div``;

export default TagList;
